import { NotifyHelper } from "../../../helpers/toast";
import { eHocKyDangKyActionsObj } from "../../action-types/lop-tin-chi/IHocKyDangKyActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const kyDangKyActions = {
  ...generateActions(eHocKyDangKyActionsObj, "HOC_KY_DANG_KY"),
  ...generateActionForKey(eHocKyDangKyActionsObj, "HOC_KY_DANG_KY", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eHocKyDangKyActionsObj, "HOC_KY_DANG_KY", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eHocKyDangKyActionsObj, "HOC_KY_DANG_KY", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(eHocKyDangKyActionsObj, "HOC_KY_DANG_KY", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
